export const NEW_NOTE_DIALOG_NAME =
  'dialog::@bangle.io/core-extension:new-note-modal';

export const RENAME_NOTE_DIALOG_NAME =
  'dialog::@bangle.io/core-extension:rename-note-modal';

export const CHANGELOG_MODAL_NAME =
  'dialog::@bangle.io/core-extension:changelog-modal';

export const NEW_WORKSPACE_DIALOG_NAME =
  'dialog::@bangle.io/core-extension:new-workspace-dialog';

export const NEW_NATIVE_FS_WORKSPACE_DIALOG_NAME =
  'dialog::@bangle.io/core-extension:NEW_NATIVE_FS_DIALOG_NAME';

export const NEW_PRIVATE_FS_WORKSPACE_DIALOG_NAME =
  'dialog::@bangle.io/core-extension:NEW_PRIVATE_FS_WORKSPACE_DIALOG_NAME';

export const NEW_BROWSER_WORKSPACE_DIALOG_NAME =
  'dialog::@bangle.io/core-extension:NEW_BROWSER_WORKSPACE_DIALOG_NAME';

export const RELOAD_APPLICATION_DIALOG_NAME =
  'dialog::@bangle.io/core-extension:reload-application-dialog';

export const GENERIC_ERROR_MODAL_NAME =
  'dialog::@bangle.io/core-extension:generic_error_modal_name';
